<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ 'bikeshop.modal.video-player.tutorial' | translate}}
        - {{ tutorial.title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <div>
        <youtube-player videoId="{{tutorial.youtube_id}}" [width]="100" [startSeconds]="20"></youtube-player>
    </div>
</div>
